import { ordersNode, userOrdersNode, storeProfilesNode } from '@/api/firebase'
import { firebaseObjectToArray } from '@/utils'
import { async, GET_ASYNC, ASYNC_MUTATIONS } from '@/utils/async'
import { ORDERS } from 'db'
import { ORDERS_LIMIT } from '@/utils/constants'

const state = {
    userOrders: false,
    userOrder: false,
    ...async()
}

const getters = {
    GET_USER_ORDERS: (state) => firebaseObjectToArray(state.userOrders),
    GET_USER_ORDER: (state) => firebaseObjectToArray(state.userOrder),
    GET_ASYNC
}

const mutations = {
    SET_USER_ORDERS(state, payload) {
        state.userOrders = payload
    },
    APPEND_USER_ORDER(state, payload) {
        state.userOrders = Object.assign({}, { ...state.userOrders }, payload)
    },
    SET_USER_ORDER(state, payload) {
        state.userOrder = payload
    },
    CLEAR_USER_ORDERS(state) {
        state.userOrders = false
    },
    CLEAR_USER_ORDER(state) {
        state.userOrder = false
    },
    ...ASYNC_MUTATIONS()
}

const actions = {
    // =================================== C/U/D Operations ===================================

    // =================================== Read Operations ===================================

    /**
     * FETCH_USER_ORDERS_BY_ID
     *
     *     Retrieve a list of user orders by user id. If empty, set false. Binds a firebase connection.
     *
     * @param payload.id {string} - The id of the user to orders for.
     * @param payload.limit {string} - The limit of orders to retrieve.
     * @returns {Void}
     */
    FETCH_USER_ORDERS_BY_ID({ commit }, payload) {
        commit('REQUEST')
        commit('CLEAR_USER_ORDERS')
        ordersNode.off()
        userOrdersNode
            .child(payload.id)
            .limitToLast(payload.limit || ORDERS_LIMIT)
            .on(
                'value',
                async function(data) {
                    try {
                        const orderIds = data.val()
                        if (orderIds) {
                            await Promise.all(
                                firebaseObjectToArray(orderIds).map(async (order) => {
                                    ordersNode.child(order.id).on(
                                        'value',
                                        async function(orderData) {
                                            const orderVal = orderData.val()
                                            const storeProfile = (await storeProfilesNode.child(orderVal[ORDERS.fields.storeId]).once('value')).val()
                                            commit('APPEND_USER_ORDER', { [order.id]: { ...orderVal, storeProfile } })
                                        },
                                        function(err) {
                                            commit('ERROR', err.message)
                                        }
                                    )
                                })
                            )
                        }
                        commit('SUCCESS')
                    } catch (err) {
                        commit('ERROR', err.message)
                    }
                },
                function(err) {
                    commit('ERROR', err.message)
                }
            )
    },

    // =================================== Listener Operations ===================================

    /**
     * REMOVE_USER_ORDERS_REFERENCE
     *
     *     Unbind a firebase connection on a child that was set.
     *
     * @param payload.id {string} - The id of the user child.
     */
    REMOVE_USER_ORDERS_REFERENCE({ commit }, payload) {
        commit('CLEAR')
        commit('CLEAR_USER_ORDER')
        userOrdersNode.child(payload.id).off()
    }
}

export { state, getters, mutations, actions }
